import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

import useAuth from 'app/hooks/useAuth';
import Logger from 'app/services/Logger';
import { requestPermissions } from 'app/services/PermissionsService';

const MODULE = '[useRequestPermissions]';

/**
 * Web only: requests the notification and location permissions once the customer
 * has signed in, and only once per session.
 *
 * Prompting during bootstrap left the site unusable until the browser prompts were
 * answered, so on web we hold them until sign in. Native still prompts on startup
 * from `useBootstrap`.
 */
export default function useRequestPermissions() {
  const { isVerified } = useAuth();
  const hasRequested = useRef(false);

  useEffect(() => {
    if (Platform.OS !== 'web' || !isVerified || hasRequested.current) return;

    hasRequested.current = true;
    requestPermissions().catch((err: unknown) => {
      Logger.error(`${MODULE} failed to request permissions`, { err });
    });
  }, [isVerified]);
}
